import { Image } from "components/image";
import { Link } from "components/link";
import { FC } from "react";

function calculateAge(birthdate: string) {
  const today = new Date();
  const birthDate = new Date(birthdate);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

export const LinkedinProfile: FC = () => {
  const myBirthdate = "2001-05-24";
  const myAge = calculateAge(myBirthdate);

  return (
    <section className="max-w-xs animate-float rounded-lg border-2 border-gray-400/30 bg-white/90 p-4 backdrop-blur-md will-change-transform spacing-2 d:bg-gray-800 lg:bg-white/80">
      <header className="flex gap-4">
        <figure className="overflow-hidden rounded-full border-2 border-gray-400/50">
          <Image
            width={40}
            height={40}
            src="https://avatars.githubusercontent.com/u/78134745?u=15e7998f99a9759ef9ad24af31686cf65183828a&v=4"
            alt="Karan"
            className="rounded-full border-2 border-accent"
          />
        </figure>
        <div className="flex flex-col justify-center">
          <h2 className="text-sm font-semibold tracking-wide">Karan</h2>
          <h3 className="text-sm tracking-tight text-gray-500 d:text-gray-300/90">@karandesai09</h3>
        </div>
        <Link
          target="_blank"
          href="https://twitter.com/Karandesai09"
          className="butter-border my-auto ml-auto flex items-center justify-center rounded-full bg-teal-500/90 px-4 py-1.5 text-xs text-white transition-colors hfa:bg-teal-600/80 d:bg-teal-600/90 d:hfa:bg-teal-500/80"
        >
          Connect
        </Link>
      </header>
      <main>
        <p className="line-clamp-3 pr-2 text-[13px] tracking-tight text-gray-500/90 d:text-gray-300/90">
           Software Developer 👨‍💻 | M on M 🏌️
        </p>
      </main>
      <footer>
        <p className="text-[13px] text-gray-500 d:text-gray-300/90">
          <span className="font-semibold text-gray-600 d:text-gray-200">962</span> Following
          <span className="ml-2 font-semibold text-gray-600 d:text-gray-200">1266</span> Followers
        </p>
      </footer>
    </section>
  );
};
